<template>
    <div class="maintenance-alert-outer">
        <div class="maintenance-alert-inner">
            <img src="../../assets/img/maintenance-icon.svg" alt="">
            <h1>Upcoming Scheduled Maintenance</h1>
            <p>We will be undergoing scheduled maintenance</p>
            <p>on Sunday morning, September 5th, between 7:00 AM - 11:00 AM EST.</p>
            <p>During this time access to the portal may be unavailable.</p>
            <button @click="clickOK()" class="btn btn-success">OK</button>
        </div>
    </div>
</template>

<script>
    import globalStore from '../../variables';
    export default {
        name: "MaintenanceAlert",
        data() {
            return {
                timeFrom: null,
                timeTo: null,
                dateParsed: ''
            }
        },
        methods: {
            clickOK() {
                this.$emit('maintenanceAccepted');
            },
            setTimeToLocal (data) {
                let dateHistoryTime = new Date(data.getTime());

                if (dateHistoryTime.getHours() > 12) {
                    let tempHour = (dateHistoryTime.getHours() + 24) % 12 || 12;
                    if (dateHistoryTime.getMinutes() == 59) {
                        var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                    } else {
                        var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                    }
                } else {
                    if (dateHistoryTime.getHours() == 0) {
                        var hoursHistory = '12' + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' AM'
                    } else {
                        var hoursHistory = dateHistoryTime.getHours() + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' AM'
                    }
                }

                let finalDate = data.getMonth() + 1 + '/' + data.getDate() + '/' + data.getFullYear() + ' ' + hoursHistory;
                return finalDate;
            },
            setDate(data) {
                let finalDate = ''
                let date = new Date(data)

                let day = date.getDay()

                if (day == 0) {
                    finalDate = finalDate + 'Sunday, '
                } else if (day == 1) {
                    finalDate = finalDate + 'Monday, '
                } else if (day == 2) {
                    finalDate = finalDate + 'Tuesday, '
                } else if (day == 3) {
                    finalDate = finalDate + 'Wednesday, '
                } else if (day == 4) {
                    finalDate = finalDate + 'Thursday, '
                } else if (day == 5) {
                    finalDate = finalDate + 'Friday, '
                } else if (day == 6) {
                    finalDate = finalDate + 'Saturday, '
                }

                let month = date.getMonth()

                if (month == 0) {
                    finalDate = finalDate + 'January '
                } else if (month == 1) {
                    finalDate = finalDate + 'February '
                } else if (month == 2) {
                    finalDate = finalDate + 'March '
                } else if (month == 3) {
                    finalDate = finalDate + 'April '
                } else if (month == 4) {
                    finalDate = finalDate + 'May '
                } else if (month == 5) {
                    finalDate = finalDate + 'June '
                } else if (month == 6) {
                    finalDate = finalDate + 'July '
                } else if (month == 7) {
                    finalDate = finalDate + 'August '
                } else if (month == 8) {
                    finalDate = finalDate + 'September '
                } else if (month == 9) {
                    finalDate = finalDate + 'October '
                } else if (month == 10) {
                    finalDate = finalDate + 'November '
                } else if (month == 11) {
                    finalDate = finalDate + 'December '
                }

                let dayOfMonth = String(date.getDate())
                let lastSign = dayOfMonth.slice(-1)

                if (lastSign == 1) {
                    finalDate = finalDate + dayOfMonth + 'st'
                } else if (lastSign == 2) {
                    finalDate = finalDate + dayOfMonth + 'nd'
                } else if (lastSign == 3) {
                    finalDate = finalDate + dayOfMonth + 'rd'
                } else {
                    finalDate = finalDate + dayOfMonth + 'th'
                }

                return finalDate
            }
        },
        mounted() {
            this.timeFrom = this.setTimeToLocal(globalStore.data.maintenance.from)
            this.timeTo = this.setTimeToLocal(globalStore.data.maintenance.to)
            this.dateParsed = this.setDate(globalStore.data.maintenance.from)
        }
    }
</script>

<style lang="scss">
    .maintenance-alert-outer {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 4000;
        .maintenance-alert-inner {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            img {
                margin-bottom: 8px;
            }
            h1 {
                margin-bottom: 20px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }
            p {
                max-width: 460px;
                margin: 0;
                font-size: 14px;
                line-height: 24px;
                text-align: center;
            }
            .btn {
                margin-top: 30px;
                padding: 8px 20px;
            }
        }
    }
</style>
